<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('DESCRIPTION')">
        <inputvalidation :formerror="formError" name="description">
          <b-form-input type="text" v-model="formData.description"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('OVERWRITE')">
        <inputvalidation :formerror="formError" name="overwrite">
            <b-form-checkbox v-model="formData.overwrite" :value="1" :unchecked-value="0">{{$t('OVERWRITE')}}</b-form-checkbox>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-12">
      <b-alert show>{{$t('JOBTYPEOVERWRITEDISCLAIMER')}}</b-alert>      
    </div>
  </div>
</div>
</template>

<script>
export default {
    name: 'MeterValueForm',
    props: ['formData', 'formError'],
};
</script>
